// extracted by mini-css-extract-plugin
export default {"authForm":"F9aKguZT","title":"sM88Wx_1","otpInfo":"tf97erZE"};